import React from 'react';
import {
  Flex,
  Box,
  Stack,
  Container,
  Text,
  Heading,
  Button,
  Link,
} from '@chakra-ui/react';

interface TryHoverTodaySectionProps {
  title?: string;
  description?: string;
  buttonText?: string;
  ctaLink?: string;
  actionText?: string;
}

const TryHoverTodaySection = ({
  title,
  description,
  buttonText,
  ctaLink = '/signup/',
  actionText,
}: TryHoverTodaySectionProps) => (
  <Box
    w="100%"
    textAlign="center"
    bgColor="gray.50"
    backgroundSize="cover"
    backgroundPosition="center center"
  >
    <Container maxW="6xl">
      <Stack
        as={Flex}
        textAlign="center"
        alignItems="center"
        spacing={8}
        py={[24, 36]}
      >
        <Heading
          fontWeight={700}
          fontSize={['3xl', '4xl', '5xl', '6xl']}
          lineHeight={['150%', '120%']}
        >
          {title}
        </Heading>
        <Text fontSize={['xl', '2xl', '3xl']} fontWeight="300">
          {description}
        </Text>
        {actionText && (
          <Text fontWeight="bold" fontSize="lg">
            {actionText}
          </Text>
        )}
        <Link href={ctaLink} color="white">
          <Button size="lg" minW="64">
            {buttonText}
          </Button>
        </Link>
      </Stack>
    </Container>
  </Box>
);

TryHoverTodaySection.defaultProps = {
  title: 'Try HOVER today',
  description: 'Start your free trial to see how HOVER measures up.',
  buttonText: 'Start Free Trial',
  ctaLink: '/signup/',
  actionText: undefined,
};

export default TryHoverTodaySection;
